import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';

import {
  displayOrDash,
  mapMiscPurchaseOrderMeta,
} from '../helper/mapMiscPurchaseOrderMeta';
import MiscPurchaseOrderStatusBadge from './MiscPurchaseOrderStatusBadge';

const InfoField = ({ label, value, className }) => (
  <div className={cn('min-w-0', className)}>
    <p className="text-xs text-gray-500">{label}</p>
    <p className="mt-0.5 text-sm font-medium wrap-break-word text-gray-900">{value}</p>
  </div>
);

InfoField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
  className: PropTypes.string,
};

const TEXT_SPAN = 'sm:col-span-2 md:col-span-2';

/** 非庫存採購單 detail 上方資訊卡：hero（單號／狀態／供應商／操作）＋ 欄位格。 */
const MiscPurchaseOrderMainInfoCard = ({ detail, actions = null }) => {
  const meta = mapMiscPurchaseOrderMeta(detail);

  return (
    <div className="receipt-card-elevate">
      <div className="receipt-card-surface p-5">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <h1 className="text-2xl font-bold text-gray-900">{meta.code}</h1>
              {meta.status ? <MiscPurchaseOrderStatusBadge status={meta.status} /> : null}
            </div>
            <p className="mt-1 text-sm text-gray-600">
              供應商：
              {meta.supplierName}
            </p>
          </div>
          {actions ? (
            <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
              {actions}
            </div>
          ) : null}
        </div>

        <div
          className={cn(
            'mt-4 grid grid-cols-1 gap-x-4 gap-y-3 border-t border-slate-200 pt-4',
            'sm:grid-cols-2 md:grid-cols-4',
          )}
        >
          <InfoField label="建立" value={meta.createDate} />
          <InfoField label="修改" value={meta.reviseDate} />
          <InfoField label="提交" value={meta.submittedDate} />
          <InfoField label="核准" value={meta.approvedDate} />

          <InfoField label="採購日" value={meta.purchaseOrderDate} />
          <InfoField label="付款條件" value={meta.paymentTerm} />
          <InfoField label="幣別／匯率" value={`${meta.currency} · ${meta.exchangeRate}`} />
          <InfoField label="結案" value={meta.closeDate} />

          {meta.hasAmount ? (
            <>
              <InfoField label="未稅小計" value={meta.subtotalAmount} />
              <InfoField label="稅額" value={meta.taxAmount} />
              <InfoField label="合計" value={meta.totalAmount} />
              <InfoField label="稅別" value={meta.taxType} />
            </>
          ) : null}

          <InfoField label="採購事由" value={displayOrDash(meta.issueReason)} className={TEXT_SPAN} />
          <InfoField label="備註" value={displayOrDash(meta.remark)} className={TEXT_SPAN} />

          {meta.rejectReason ? (
            <InfoField label="退回原因" value={meta.rejectReason} className={TEXT_SPAN} />
          ) : null}
          {meta.closeReason ? (
            <InfoField label="結案原因" value={meta.closeReason} className={TEXT_SPAN} />
          ) : null}
          {meta.terminateReason ? (
            <InfoField
              label="中止原因"
              value={`${meta.terminateReason}（${meta.terminateDate}）`}
              className={TEXT_SPAN}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

MiscPurchaseOrderMainInfoCard.propTypes = {
  detail: PropTypes.object.isRequired,
  actions: PropTypes.node,
};

export default MiscPurchaseOrderMainInfoCard;
